import React from 'react';

import { ContentPlacement } from '@candu-ai/placement/types';
import { useActiveTooltip } from 'craft/components/Tooltip';
import {
  TOOLTIP_PLACEMENTS_CUSTOMIZATION,
} from 'craft/containers/Toolbox/tabs/Placements/TooltipPlacements/TooltipPlacementsCustomization';
import { PlacementSteps, StepSectionTitle, StepTitle } from 'craft/containers/Toolbox/tabs/Placements/components/ui';
import { TooltipType } from 'craft/types/TooltipType';

import { HotspotGroupUrl } from './HotspotGroupUrl';
import { TooltipHTMLSelector } from './TooltipHTMLSelector';

interface StepTwoProps {
  placement: ContentPlacement;
  onEditUrl: VoidFunction;
  stepOneSelector?: string;
  handleRetargetClick: () => void;
  onSave: () => void;
  contentType: TooltipType;
}

export const StepTwo = ({
  placement,
  onEditUrl,
  stepOneSelector,
  handleRetargetClick,
  onSave,
  contentType,
}: StepTwoProps) => {
  const activeTooltip = useActiveTooltip();

  if (!activeTooltip) {
    throw new Error('Trying to render Hotspot placement without an active Hotspot');
  }

  return (
    <PlacementSteps>
      <div>
        <StepTitle active size="short">
          {TOOLTIP_PLACEMENTS_CUSTOMIZATION[contentType].title}
        </StepTitle>

        <StepSectionTitle>
          {TOOLTIP_PLACEMENTS_CUSTOMIZATION[contentType].urlLabel}
        </StepSectionTitle>
        <HotspotGroupUrl onEdit={onEditUrl} />

        <StepSectionTitle>
          {TOOLTIP_PLACEMENTS_CUSTOMIZATION[contentType].selectorLabel}
        </StepSectionTitle>
        <TooltipHTMLSelector
          key={activeTooltip.id}
          hotspotId={activeTooltip.id}
          contentPlacement={placement}
          stepOneSelector={stepOneSelector}
          handleRetargetClick={handleRetargetClick}
          onSave={onSave}
        />
      </div>
    </PlacementSteps>
  );
};
